import { getContext } from '@fiverr-private/fiverr_context';

export const getDefaultCollection = (collections) => collections[0];

export const getDefaultCollectionName = () => {
    const { locale } = getContext();

    return i18n.t('collect_package.default_collection_name', { $scope: locale });
};
